import React, { type PropsWithChildren, useMemo } from 'react';

import { ModalContextProvider } from '@atlassian/entry-point-modal-context/ModalContextProvider';
import { BFFConsumerEnum, BFFProvider } from '@atlassian/navigation-bff-data-provider';

import { type UseSideNavUserData } from '../../common/types';
import { AsyncIntlProvider } from '../../common/utils/locale';
import { UserMenuDataProvider } from '../../controllers/user-state/user-menu-data-provider';
import { UserSideNavDataProvider } from '../../controllers/user-state/user-side-nav-data-provider';

type GlobalSideNavWrapperProps = PropsWithChildren & UseSideNavUserData;

export function GlobalSideNavWrapper(props: GlobalSideNavWrapperProps) {
	const { children, userMenuData, userSideNavData, setUserMenuData, setUserSideNavData } = props;

	// Split the data into two separate contexts, as they are edited at 2 different times.
	// (but we must always send an update with both data-sets inside)
	const userMenuValue = useMemo(
		() => ({ userMenuData, setUserMenuData }),
		[userMenuData, setUserMenuData],
	);

	const userSideNavValue = useMemo(
		() => ({ userSideNavData, setUserSideNavData }),
		[userSideNavData, setUserSideNavData],
	);

	return (
		<AsyncIntlProvider>
			<ModalContextProvider>
				<BFFProvider consumer={BFFConsumerEnum.GLOBAL_SIDE_NAVIGATION}>
					<UserMenuDataProvider value={userMenuValue}>
						<UserSideNavDataProvider value={userSideNavValue}>{children}</UserSideNavDataProvider>
					</UserMenuDataProvider>
				</BFFProvider>
			</ModalContextProvider>
		</AsyncIntlProvider>
	);
}
